import React from "react"

export const AccessibilityContext = React.createContext({
    audio: false,
})

const useAccessibility = () => React.useContext(AccessibilityContext)

export default useAccessibility
